import type { Libraries } from '@react-google-maps/api';

export const DEFAULT_MAP_CENTER = { lat: 53.3463247, lng: -6.263098 };
export const libraries = ['places', 'geometry', 'drawing'] as Libraries;
